module.exports = __webpack_public_path__ + "static/Arrival_Drop_Off-0317bf54b5496e8878e78db70af6599b.jpg";